import type { NormaliseCableType } from "./types";

export const normaliseCableType: NormaliseCableType = (cableType) =>
  cableType
    .replace(/mm\s*[²2]/gi, "")
    .replace(/[×*]/g, "x")
    .replace(/\s*x\s*/gi, "x")
    .replace(/\./g, ",")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
